/* eslint-disable */

import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';

import { CircularProgress } from 'material-ui/Progress';
import Button from 'material-ui/Button';
import Card, { CardHeader, CardContent } from 'material-ui/Card';

import { Row } from 'react-flexbox-grid';
import IconButton from 'material-ui/IconButton';
import CreateIcon from 'material-ui-icons/Create';

import { FiCalendar } from 'react-icons/fi';

import { CSSTransitionGroup } from 'react-transition-group';

import { FormControl } from 'material-ui/Form';

import moment from 'moment';

import 'react-infinite-calendar/styles.css';

import { Chart } from 'react-chartjs-2';
import Grid from 'material-ui/Grid';
import { withRouter } from 'react-router';
import * as XLSX from 'xlsx';

import { assets } from '../../assets/';

import { translate } from 'react-i18next';

import {
  getAssetsProducingStart,
  getAssetConsumingStart,
  getAssetConsumingRefresh,
  setUnit,
  toggleStacked,
  toggleDateFilter,
  hideDateFilter,
  displayDateFilter,
  setCustomButtonPressed,
  setThirtyDayButtonPressed,
  setTwelveMonthsButtonPressed,
  setOneYearButtonPressed,
  setMapZoomAndCenter,
  toggleStartDateDialog,
  toggleEndDateDialog,
  toggleCo2DetailsDialog,
  setStartDate,
  setEndDate,
  getAverageDistanceFromAsset,
} from '../../actions';

import {
  resetCardsUnderlyingValues,
  startLoading,
  stopLoading,
  resetGraphData,
} from '../../actions/AssetsConsumingActions';

import { checkUserIsAdmin } from '../../utils/user/checkAdmin/CheckAdmin';

import { enums } from '../../enums/';
import { constants } from '../../constants/index';
import { styles } from './style';

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

/**
 * Sub components import
 */
import { AvoidedCO2Card } from '../EquivalentToCards/AvoidedCO2/AvoidedCO2Card';
import { ConvertedAvoidedCO2Card } from '../EquivalentToCards/ConvertedAvoidedCO2/ConvertedAvoidedCO2Card';
import { GreenElectricityCard as GreenElectricityCardNew } from '../EquivalentToCards/GreenElectricity/GreenElectricityCard';
import { DoughnutCard } from '../ChartCards/DoughnutCard';
import { BarChartCard } from '../ChartCards/BarChartCard';
import { HeatMapCard } from '../ChartCards/HeatMapCard';
import { MapCard } from '../MapCards/MapCard';
import { AverageDistanceCard } from '../EquivalentToCards/AverageDistance/AverageDistanceCard';
import { AvoidedCO2Dialog } from '../EquivalentToCards/AvoidedCO2/AvoidedCO2Dialog';
import ChartCardMenu from '../ChartCards/ChartCardMenu';
import { HourlyDoughnutCard } from '../ChartCards/HourlyDoughnutCard';

/**
 * Asset Consuming page main component
 */
class AssetConsuming extends React.Component {
  static contextTypes = {
    router: PropTypes.func.isRequired,
  };

  static defaultProps = {
    zoom: 11,
  };

  state = {
    anchorEl: null,
  };

  hasCertificates30Days = () => {
    const certificatesData = this.props.barChartData.data
      ? this.props.barChartData.data
      : [];
    let certificatesNumber = 0;

    certificatesData.map((assetData, index) => {
      const assetCertificatesNumber = assetData.data
        ? assetData.data.length
        : 0;
      if (index < certificatesData.length - 1) {
        certificatesNumber += assetCertificatesNumber;
      }
    });
    return certificatesNumber > 0 ? true : false;
  };

  exportData = () => {
    const barChartLabels = this.props.barChartData.labels;
    const barChartData = this.props.barChartData.data;

    let dataToExport = [['Date']];
    barChartData.map(item => {
      dataToExport[0].push(item.label + ' (' + enums.Unit.KWH + ')');
    });

    for (let i = 0; i < barChartLabels.length; i++) {
      let exportLine = [new Date(barChartLabels[i])];
      barChartData.map(item => {
        exportLine.push(item.data[i]);
      });
      dataToExport.push(exportLine);
    }
    if (dataToExport && dataToExport.length > 0) {
      /* generate worksheet */
      const ws = XLSX.utils.aoa_to_sheet(dataToExport);

      /* generate workbook and add the worksheet */
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      XLSX.writeFile(wb, 'attributes-data-export-overview.xlsx');
    }
  };

  /**
   * Custom event handlers
   */
  handleMenuClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  };

  /**
   * React events
   */
  componentWillMount = () => {
    Chart.pluginService.register({
      beforeDraw: function(chart) {
        if (chart.config.options.elements.center) {
          //Get ctx from string
          var ctx = chart.chart.ctx;

          //Get options from the center object in options
          var centerConfig = chart.config.options.elements.center;
          var fontStyle =
            centerConfig.fontStyle ||
            '"Inter-Regular", "Avenir", "Helvetica", "Arial", sans-serif';
          var txt = centerConfig.text;
          var color = centerConfig.color || '#000';
          var sidePadding = centerConfig.sidePadding || 20;
          var sidePaddingCalculated =
            (sidePadding / 100) * (chart.innerRadius * 2);
          //Start with a base font of 30px
          ctx.font = '20px ' + fontStyle;

          //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
          var stringWidth = ctx.measureText(txt).width;
          var elementWidth = chart.innerRadius * 2 - sidePaddingCalculated;

          // Find out how much the font can grow in width.
          var widthRatio = elementWidth / stringWidth;
          var newFontSize = Math.floor(20 * widthRatio);
          var elementHeight = chart.innerRadius * 2;

          // Pick a new font size so it will not be larger than the height of label.
          var fontSizeToUse = Math.min(newFontSize, elementHeight);

          //Set font settings to draw it correctly.
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
          var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
          ctx.font = fontSizeToUse + 'px ' + fontStyle;
          ctx.fillStyle = color;

          //Draw text in center
          ctx.fillText(txt, centerX, centerY);
        }
      },
    });
  };

  componentDidMount = async () => {
    if (this.props.isAuthenticated) {
      const {
        match: { params },
      } = this.props;
      await this.props.startLoading();
      await this.props.resetCardsUnderlyingValues();
      await this.props.resetGraphData();
      this.props.hideDateFilter();
      await this.props.getAssetConsumingStart(
        params.assetId,
        this.props.history
      );
      await this.props.stopLoading();
    } else {
      this.props.history.push('/unauthorized');
    }
  };

  renderCurrentYearFilterButton() {
    const { classes, currentAssetConsuming, refreshingOnChain } = this.props;

    const buttonClassname = classNames({
      [classes.buttonSuccess]: refreshingOnChain,
    });

    return (
      <Button
        color="primary"
        variant={this.props.oneYearButtonPressed ? 'raised' : 'flat'}
        className={buttonClassname}
        disabled={refreshingOnChain}
        onClick={async () => {
          this.props.setOneYearButtonPressed();
          this.props.hideDateFilter();

          await this.props.startLoading();
          await this.props.getAssetConsumingStart(
            currentAssetConsuming.id,
            this.props.history
          );
          await this.props.stopLoading();
        }}
        type="submit"
      >
        {refreshingOnChain ? (
          <CircularProgress size={24} className={classes.buttonProgress} />
        ) : (
          'This year'
        )}
      </Button>
    );
  }

  renderThirtyDaysFilterButton() {
    const { classes, currentAssetConsuming, refreshingOnChain } = this.props;

    const buttonClassname = classNames({
      [classes.buttonSuccess]: refreshingOnChain,
    });

    return (
      <Button
        variant={this.props.thirtyDaysButtonPressed ? 'raised' : 'flat'}
        color="primary"
        className={buttonClassname}
        disabled={refreshingOnChain}
        onClick={async () => {
          this.props.setThirtyDayButtonPressed();
          this.props.hideDateFilter();
          await this.props.startLoading();
          await this.props.getAssetConsumingStart(
            currentAssetConsuming.id,
            this.props.history
          );
          await this.props.stopLoading();
        }}
        type="submit"
      >
        {refreshingOnChain ? (
          <CircularProgress size={24} className={classes.buttonProgress} />
        ) : (
          '30 days'
        )}
      </Button>
    );
  }

  render12MonthsFilterButton() {
    const { classes, currentAssetConsuming, refreshingOnChain } = this.props;

    const buttonClassname = classNames({
      [classes.buttonSuccess]: refreshingOnChain,
    });

    return (
      <Button
        variant={this.props.twelveMonthsButtonPressed ? 'raised' : 'flat'}
        color="primary"
        className={buttonClassname}
        disabled={refreshingOnChain}
        onClick={async () => {
          this.props.setTwelveMonthsButtonPressed();
          this.props.hideDateFilter();
          await this.props.startLoading();
          await this.props.getAssetConsumingStart(
            currentAssetConsuming.id,
            this.props.history
          );
          await this.props.stopLoading();
        }}
        type="submit"
      >
        {refreshingOnChain ? (
          <CircularProgress size={24} className={classes.buttonProgress} />
        ) : (
          '12 Months'
        )}
      </Button>
    );
  }
  renderCustomButton() {
    const { classes, refreshingOnChain } = this.props;

    return (
      <Button
        color="primary"
        variant={this.props.customButtonPressed ? 'raised' : 'flat'}
        className={classes.button}
        disabled={refreshingOnChain}
        onClick={() => {
          this.props.setCustomButtonPressed();
          this.props.displayDateFilter();
        }}
      >
        {refreshingOnChain ? (
          <CircularProgress size={24} className={classes.buttonProgress} />
        ) : (
          'Custom'
        )}
      </Button>
    );
  }

  renderFormContainer() {
    return (
      <Grid item xs={12} sm={12} style={{ minWidth: '100%' }}>
        <div style={{ float: 'left' }}>
          <CSSTransitionGroup
            transitionName="example"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={300}
          >
            {this.props.showDateFilter ? this.renderForm() : false}
          </CSSTransitionGroup>
        </div>
      </Grid>
    );
  }

  renderForm() {
    const { classes, t, currentAssetConsuming, refreshingOnChain } = this.props;
    const {
      dialogStartDateOpen,
      dialogEndDateOpen,
      startDate,
      endDate,
    } = this.props;

    const buttonClassname = classNames({
      [classes.buttonSuccess]: refreshingOnChain,
    });

    let dateFormat = 'yyyy/MM/dd'; //English date
    if (this.props.i18n.language === 'fr') {
      dateFormat = 'dd/MM/yyyy';
    } else if (this.props.i18n.language === 'en_us') {
      dateFormat = 'MM/dd/yyyy'; //American date
    }

    return (
      <Row>
        <FormControl style={{ width: 167 }}>
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 18,
            }}
          />
          <div style={{ marginTop: 12 }}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                format={dateFormat}
                openTo={'year'}
                label="start date"
                value={startDate}
                onChange={newDate => {
                  if (!moment(newDate).isValid() || !newDate) {
                    newDate = null;
                  }

                  this.props.setStartDate(newDate);
                }}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
                className={classes.inputWithMargin}
              />
            </MuiPickersUtilsProvider>
          </div>
        </FormControl>

        <FormControl style={{ width: 167 }}>
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 18,
            }}
          />
          <div style={{ marginTop: 12, marginLeft: 12 }}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                format={dateFormat}
                openTo={'year'}
                label="start date"
                value={endDate}
                onChange={newDate => {
                  if (!moment(newDate).isValid() || !newDate) {
                    newDate = null;
                  }

                  this.props.setEndDate(newDate);
                }}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
                className={classes.inputWithMargin}
              />
            </MuiPickersUtilsProvider>
          </div>
        </FormControl>
        <Button
          style={{ marginLeft: 12, marginTop: 20 }}
          variant="raised"
          color="primary"
          className={buttonClassname}
          disabled={refreshingOnChain}
          onClick={async () => {
            await this.props.startLoading();
            await this.props.getAssetConsumingRefresh(
              currentAssetConsuming.id,
              this.props.history,
              moment(startDate).format('YYYY-MM-DD'),
              moment(endDate).format('YYYY-MM-DD')
            );
            await this.props.stopLoading();
          }}
          type="submit"
        >
          {refreshingOnChain ? (
            <CircularProgress size={24} className={classes.buttonProgress} />
          ) : (
            'Ok'
          )}
        </Button>
      </Row>
    );
  }

  renderFormButton() {
    return (
      <Grid item xs={12}>
        <IconButton
          aria-label="Filter list"
          onClick={() => this.props.toggleDateFilter()}
        >
          <FiCalendar style={{ fontSize: 18 }} />
        </IconButton>
        <CSSTransitionGroup
          transitionName="example"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={300}
        >
          {this.props.showDateFilter ? this.renderForm() : false}
        </CSSTransitionGroup>
      </Grid>
    );
  }

  renderTimeNavigation() {
    const { currentAssetConsuming } = this.props;

    let frequency =
      currentAssetConsuming.organization.parentOrganization.matchingType
        .frequency;
    return (
      <Grid item xs={12} sm={12} style={{ minWidth: '100%' }}>
        <div style={{ float: 'left' }}>
          <div style={{ marginRight: 10, float: 'left' }}>
            {/*this.renderCurrentYearFilterButton()
            //TODO reactivate this button later
            */}
          </div>
          <div style={{ marginLeft: 10, marginRight: 10, float: 'left' }}>
            {frequency === enums.FrequencyTypes.DAILY ||
            frequency === enums.FrequencyTypes.HOURLY
              ? this.renderThirtyDaysFilterButton()
              : this.render12MonthsFilterButton()}
          </div>

          <div style={{ marginLeft: 10, float: 'left' }}>
            {this.renderCustomButton()}
          </div>
        </div>
      </Grid>
    );
  }

  renderUpdateButton(history) {
    const {
      classes,
      user,
      isAuthenticated,
      currentAssetConsuming,
    } = this.props;
    if (checkUserIsAdmin(isAuthenticated, user)) {
      return (
        <Button
          variant="fab"
          color="primary"
          aria-label="add"
          className={classes.button}
          style={{
            margin: 0,
            bottom: 'auto',
            right: 48,
            top: 85,
            left: 'auto',
            position: 'fixed',
          }}
          onClick={() => {
            this.props.history.push(
              '/assets/cons/update/' + currentAssetConsuming.id
            );
          }}
        >
          <CreateIcon />
        </Button>
      );
    } else return false;
  }

  render() {
    const {
      classes,
      currentAssetConsuming,
      loading,
      t,
      loadingYTDOnChain,
      loadingOnChain,
      frontEndDataForConsumingAsset,
      endDate,
      startDate,
      equivalentCardsEndDate,
      equivalentCardsStartDate,
      user,
    } = this.props;

    const assetConsumingLat =
      currentAssetConsuming && currentAssetConsuming.gpsLatitude
        ? parseFloat(currentAssetConsuming.gpsLatitude)
        : constants.MapConstants.DEFAULT_ASSET_LATITUDE;
    const assetConsumingLng =
      currentAssetConsuming && currentAssetConsuming.gpsLongitude
        ? parseFloat(currentAssetConsuming.gpsLongitude)
        : constants.MapConstants.DEFAULT_ASSET_LONGITUDE;

    const assetCenter = {
      lat: assetConsumingLat,
      lng: assetConsumingLng,
    };
    const center =
      this.props.mapCenter &&
      this.props.mapCenter.lat &&
      this.props.mapCenter.lng
        ? this.props.mapCenter
        : assetCenter;

    const defaultCenter = assetCenter;
    const zoom = this.props.zoom;

    const forecastUrl =
      'https://forecast.io/embed/#lat=' +
      assetConsumingLat +
      '&lon=' +
      assetConsumingLng +
      '&name=' +
      currentAssetConsuming.city +
      '&color=#F87733&font=Avenir&units=ca';

    let isStillLoading =
      loading ||
      loadingYTDOnChain ||
      loadingOnChain ||
      !currentAssetConsuming.name;

    if (isStillLoading) {
      return (
        <Grid container direction="row" justify="center" alignItems="stretch">
          <CircularProgress size={24} />
        </Grid>
      );
    }
    let frequency =
      currentAssetConsuming.organization.parentOrganization.matchingType
        .frequency;

    let dateRangeText = '';

    if (
      (frequency === enums.FrequencyTypes.DAILY ||
        frequency === enums.FrequencyTypes.HOURLY) &&
      this.props.thirtyDaysButtonPressed
    )
      dateRangeText = t('Last 30 days');
    if (
      frequency === enums.FrequencyTypes.MONTHLY &&
      this.props.twelveMonthsButtonPressed
    )
      dateRangeText = t('Last 12 months');
    if (this.props.oneYearButtonPressed) dateRangeText = t('Yearly');
    if (this.props.customButtonPressed)
      dateRangeText = `${t('From')} ${moment(startDate).format(
        'YYYY-MM-DD'
      )} ${t('to')}  ${moment(endDate).format('YYYY-MM-DD')}`;

    let dateFormat = 'YYYY-MM-DD'; //English date
    if (this.props.i18n.language === 'fr') {
      dateFormat = 'DD-MM-YYYY';
    } else if (this.props.i18n.language === 'en_us') {
      dateFormat = 'MM-DD-YYYY'; //American date
    }

    let monthFormat = 'YYYY-MM';
    if (this.props.i18n.language === 'fr') {
      monthFormat = 'MM-YYYY';
    }

    dateRangeText = `${t('From')} ${moment(startDate).format(dateFormat)} ${t(
      'to'
    )}  ${moment(endDate).format(dateFormat)}`;
    let equivalentCardsDateRangeText = dateRangeText;

    if (frequency === enums.FrequencyTypes.MONTHLY) {
      dateRangeText = `${t('From')} ${moment(startDate).format(
        monthFormat
      )} ${t('to')}  ${moment(endDate).format(monthFormat)}`;
      equivalentCardsDateRangeText = `${t('From')} ${moment(
        equivalentCardsStartDate
      ).format(monthFormat)} ${t('to')}  ${moment(
        equivalentCardsEndDate
      ).format(monthFormat)}`;
    }

    return (
      <div className={classes.root}>
        {this.renderUpdateButton()}
        <Grid container spacing={24}>
          {this.renderTimeNavigation()}
          {this.renderFormContainer()}

          <Grid item xs={12}>
            <Card className={classes.card}>
              <CardHeader
                title={currentAssetConsuming.name}
                subheader={
                  currentAssetConsuming.houseNumber +
                  ' ' +
                  currentAssetConsuming.street +
                  ', ' +
                  currentAssetConsuming.zip +
                  ', ' +
                  currentAssetConsuming.city +
                  ', ' +
                  currentAssetConsuming.region +
                  ', ' +
                  currentAssetConsuming.country
                }
              />
            </Card>
          </Grid>

          <AvoidedCO2Card
            user={user}
            classes={classes}
            t={t}
            loading={loading || loadingOnChain || loadingYTDOnChain}
            infoButtonHandler={this.props.toggleCo2DetailsDialog}
            avoidedCO2GramsRange={
              frontEndDataForConsumingAsset.totalAvoidedCO2GramsForRange
            }
            avoidedCO2GramsYTD={
              frontEndDataForConsumingAsset.totalAvoidedCO2GramsYearToDate
            }
            dateRangeText={equivalentCardsDateRangeText}
          />

          <ConvertedAvoidedCO2Card
            user={user}
            currentAssetConsuming={currentAssetConsuming}
            classes={classes}
            t={t}
            loading={loading || loadingOnChain || loadingYTDOnChain}
            infoButtonHandler={this.props.toggleCo2DetailsDialog}
            avoidedCO2GramsYTD={
              frontEndDataForConsumingAsset.totalAvoidedCO2GramsYearToDate
            }
            energyMatchedInWhYTD={
              frontEndDataForConsumingAsset.totalEnergyMatchedInWhYearToDate
            }
            dateRangeText={equivalentCardsDateRangeText}
            co2Equivalents={frontEndDataForConsumingAsset.CO2Equivalents}
          />

          <GreenElectricityCardNew
            currentAssetConsuming={currentAssetConsuming}
            classes={classes}
            t={t}
            loading={loading || loadingOnChain || loadingYTDOnChain}
            energyInWhForRange={
              frontEndDataForConsumingAsset.totalEnergyMatchedInWhForRange
            }
            energyInWhYTD={
              frontEndDataForConsumingAsset.totalEnergyMatchedInWhYearToDate
            }
            dateRangeText={equivalentCardsDateRangeText}
          />

          <AverageDistanceCard
            user={user}
            currentAssetConsuming={currentAssetConsuming}
            classes={classes}
            t={t}
            loading={loading || loadingOnChain || loadingYTDOnChain}
            averageDistanceInMetersForRange={
              frontEndDataForConsumingAsset.averageDistanceForRangeInMeters
            }
            averageDistanceInMetersYTD={
              frontEndDataForConsumingAsset.averageDistanceYTDInMeters
            }
            dateRangeText={equivalentCardsDateRangeText}
          />

          <BarChartCard
            ref={ref => {
              this.myBarChartOnChain = ref;
            }}
            type={
              currentAssetConsuming &&
              currentAssetConsuming.organization &&
              currentAssetConsuming.organization.parentOrganization &&
              currentAssetConsuming.organization.parentOrganization
                .matchingType &&
              currentAssetConsuming.organization.parentOrganization.matchingType
                .frequency &&
              currentAssetConsuming.organization.parentOrganization.matchingType
                .frequency === enums.FrequencyTypes.HOURLY
                ? 'bar'
                : 'bar'
            }
            dateDisplayOptions={
              currentAssetConsuming &&
              currentAssetConsuming.organization &&
              currentAssetConsuming.organization.parentOrganization &&
              currentAssetConsuming.organization.parentOrganization
                .matchingType &&
              currentAssetConsuming.organization.parentOrganization.matchingType
                .frequency &&
              currentAssetConsuming.organization.parentOrganization.matchingType
                .frequency === enums.FrequencyTypes.HOURLY
                ? 'hourly'
                : 'daily'
            }
            key="longPeriodBarChartCard"
            chartName="longPeriodBarChartCard"
            chartRef={this.myBarChartOnChain}
            classes={classes}
            unit={this.props.unit}
            assetsProducing={this.props.assetsProducing}
            currentAssetConsuming={this.props.currentAssetConsuming}
            stacked={this.props.stacked}
            loadingOnChain={this.props.loadingOnChain}
            barChartData={this.props.barChartData}
            t={t}
            i18n={this.props.i18n}
            loading={loading || loadingOnChain || loadingYTDOnChain}
            avatar={
              <img src={assets.icons.chartIcon} style={{ maxHeight: 20 }} />
            }
            title={`${t(
              'Consumption & related Production'
            )} (${dateRangeText})`}
            subheader={
              this.props.unit
                ? `${t(
                    'The consumption of the asset compared to the renewable energy producing assets'
                  )} (${this.props.unit})`
                : t(
                    'The consumption of the asset compared to the renewable energy producing assets'
                  )
            }
            menuComponent={
              <ChartCardMenu
                setUnit={this.props.setUnit}
                toggleStacked={this.props.toggleStacked}
                exportData={this.exportData}
                stacked={this.props.stacked}
                t={t}
              />
            }
          />

          <DoughnutCard
            classes={classes}
            t={t}
            key="longPeriodDoughnutCard"
            chartName="longPeriodDoughnutCard"
            loading={loading || loadingOnChain || loadingYTDOnChain}
            title={`${t('Energy sources ratio')} (${dateRangeText})`}
            subTitle={t("The sources of your asset's energy consumption")}
            centralPercentage={
              this.props.doughnutChartData.percentageOfTotalMatchedEnergy
            }
            percentageWithLabelArray={
              this.props.doughnutChartData.percentagesArray
            }
          />
          <MapCard
            {...this.props}
            defaultCenter={defaultCenter}
            center={center}
          />

          {currentAssetConsuming &&
            currentAssetConsuming.organization &&
            currentAssetConsuming.organization.parentOrganization &&
            currentAssetConsuming.organization.parentOrganization
              .matchingType &&
            currentAssetConsuming.organization.parentOrganization.matchingType
              .frequency &&
            currentAssetConsuming.organization.parentOrganization.matchingType
              .frequency === enums.FrequencyTypes.HOURLY && (
              <HeatMapCard
                chartName="heatMap"
                classes={classes}
                heatMapData={this.props.barChartData}
                t={t}
                i18n={this.props.i18n}
                loading={loading || loadingOnChain || loadingYTDOnChain}
                avatar={
                  <img src={assets.icons.chartIcon} style={{ maxHeight: 20 }} />
                }
                title={`${t('Matching ratio')} (${dateRangeText})`}
                subheader={t('The matching rate for each date and hour')}
              />
            )}

          {currentAssetConsuming &&
            currentAssetConsuming.organization &&
            currentAssetConsuming.organization.parentOrganization &&
            currentAssetConsuming.organization.parentOrganization
              .matchingType &&
            currentAssetConsuming.organization.parentOrganization.matchingType
              .frequency &&
            currentAssetConsuming.organization.parentOrganization.matchingType
              .frequency === enums.FrequencyTypes.HOURLY && (
              <Grid container spacing={24} alignItems="center" justify="center">
                <HourlyDoughnutCard
                  classes={classes}
                  t={t}
                  i18n={this.props.i18n}
                  key="hourlyDoughnutCard"
                  chartName="hourlyDoughnutCard"
                  loading={loading || loadingOnChain || loadingYTDOnChain}
                  title={`${t('Average matching ratio')} (${dateRangeText})`}
                  subTitle={t('The average matching rate per hour')}
                  barChartData={this.props.barChartData}
                />
              </Grid>
            )}
          <AvoidedCO2Dialog
            t={t}
            user={user}
            isOpen={this.props.dialogCo2DetailsOpen}
            toggle={this.props.toggleCo2DetailsDialog}
            co2Equivalents={frontEndDataForConsumingAsset.CO2Equivalents}
          />
          {false && (
            <Grid item xs={12}>
              <Card className={classes.card}>
                <CardHeader title={t('Weather')} subheader={t('Forecast')} />
                {currentAssetConsuming.gpsLatitude &&
                currentAssetConsuming.city ? (
                  <iframe
                    id="forecast_embed"
                    frameBorder="0"
                    width="100%"
                    height="245"
                    src={forecastUrl}
                  />
                ) : (
                  ''
                )}
              </Card>
            </Grid>
          )}
        </Grid>
      </div>
    );
  }
}

AssetConsuming.contextTypes = {
  router: PropTypes.object,
};
AssetConsuming.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = ({
  assetsProducingReducer,
  assetsConsumingReducer,
  router,
  loginReducer,
  transportCertificatesReducer,
  utilsReducer,
}) => {
  const { assetsProducing } = assetsProducingReducer;
  const {
    currentAssetConsuming,
    loading,
    graphData,
    loadingOnChain,
    doughnutChartData,
    barChartData,
    loadingYTD,
    yearToDateData,
    loadingYTDOnChain,
    loadingConsumingMeterRead,
    refreshing,
    dialogCo2DetailsOpen,
    consumingAssetTotalYearToDateAvoidedCO2,
    graphDataForRangeOfficialOnly,
    frontEndDataForConsumingAsset,
    producingAssetPercentageForRange,
    producingAssetPercentageYTD,
    doughnutDataForRange,
    doughnutDataYTD,
    doughnutDataLastMatchedDay,
    lastMatchedDay,
    producingAssetPercentageLastMatchedDay,
    averageDistanceForRangeInMeters,
    averageDistanceYTDInMeters,
    oneYearButtonPressed,
    twelveMonthsButtonPressed,
    thirtyDaysButtonPressed,
    customButtonPressed,
  } = assetsConsumingReducer;
  const { unit, stacked, zoom, mapCenter, showDateFilter } = utilsReducer;
  const { location } = router;
  const { isAuthenticated, username, user } = loginReducer;
  const {
    dialogStartDateOpen,
    startDate,
    equivalentCardsStartDate,
    dialogEndDateOpen,
    endDate,
    equivalentCardsEndDate,
  } = transportCertificatesReducer;

  return {
    unit,
    stacked,
    assetsProducing,
    currentAssetConsuming,
    refreshing,
    loading,
    loadingYTD,
    yearToDateData,
    graphData,
    loadingOnChain,
    loadingYTDOnChain,
    doughnutChartData,
    barChartData,
    location,
    loadingConsumingMeterRead,
    isAuthenticated,
    username,
    user,
    zoom,
    mapCenter,
    dialogStartDateOpen,
    startDate,
    equivalentCardsStartDate,
    dialogEndDateOpen,
    endDate,
    equivalentCardsEndDate,
    dialogCo2DetailsOpen,
    showDateFilter,
    consumingAssetTotalYearToDateAvoidedCO2,
    graphDataForRangeOfficialOnly,
    frontEndDataForConsumingAsset,
    producingAssetPercentageForRange,
    producingAssetPercentageYTD,
    doughnutDataForRange,
    doughnutDataYTD,
    doughnutDataLastMatchedDay,
    lastMatchedDay,
    producingAssetPercentageLastMatchedDay,
    averageDistanceForRangeInMeters,
    averageDistanceYTDInMeters,
    oneYearButtonPressed,
    thirtyDaysButtonPressed,
    customButtonPressed,
    twelveMonthsButtonPressed,
  };
};

const mapDispatchToProps = {
  getAssetsProducingStart,
  getAssetConsumingStart,
  getAssetConsumingRefresh,
  setUnit,
  toggleStacked,
  toggleDateFilter,
  hideDateFilter,
  displayDateFilter,
  setCustomButtonPressed,
  setThirtyDayButtonPressed,
  setTwelveMonthsButtonPressed,
  setOneYearButtonPressed,
  setMapZoomAndCenter,
  toggleStartDateDialog,
  toggleEndDateDialog,
  toggleCo2DetailsDialog,
  setStartDate,
  setEndDate,
  getAverageDistanceFromAsset,
  resetCardsUnderlyingValues,
  startLoading,
  stopLoading,
  resetGraphData,
};

AssetConsuming = withStyles(styles, { name: 'AssetConsuming' })(AssetConsuming);
AssetConsuming = translate('translations')(AssetConsuming);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AssetConsuming)
);



// WEBPACK FOOTER //
// ./src/components/AssetConsuming/AssetConsuming.js